import _get from 'lodash/get';

const savedPoiKey = savedPoi => {
  const deliveryDetails = _get(savedPoi, 'sp_ext_info');
  return `savedPoi-${_get(savedPoi, 'id')}-${_get(
    deliveryDetails,
    'contact_name',
  )}-${_get(deliveryDetails, 'contact_number')}`;
};

export default savedPoiKey;
